import { useInView } from 'react-intersection-observer';
import cn from 'clsx';

import styles from './Placeholder.module.css';

interface PlaceholderProps {
  className?: string;
  children: React.ReactNode;
}

export const Placeholder = ({ className, children }: PlaceholderProps) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.05,
  });

  return (
    <span className={cn(styles.placeholder, className)} data-in-view={inView}>
      <span className={styles.content} ref={ref} data-in-view={inView}>
        {children}
      </span>
    </span>
  );
};

export const ImageWrapper = ({ className, children }: PlaceholderProps) => {
  return <span className={cn(styles.imageWrapper, className)}>{children}</span>;
};
